module.exports = __webpack_public_path__ + "img/image-lock-grey.4e4114d0.svg";